import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { ChatbotComponent } from '../chatbot/chatbot.component';
import { MobileNavbarComponent } from '../mobile-navbar/mobile-navbar.component';
import { OnlyIndicationService } from '../../../core/services/only-indication.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'umkt-layout',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    FooterComponent,
    ChatbotComponent,
    MobileNavbarComponent,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  readonly chatbotEnabled = environment.production;
  readonly onlyIndicationService = inject(OnlyIndicationService);
}
